import { motion } from 'framer-motion';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function GainsCard() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="bg-white rounded-xl shadow-lg p-8 text-center"
    >
      <h3 className="text-primary mb-4">Double Your Gains with RENT</h3>
      <div className="max-w-3xl mx-auto space-y-4 mb-8">
        <p className="text-body-large text-gray-700">
          RENT token holders benefit from <span className="text-secondary font-semibold">two powerful income streams</span>:
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-gray-50 p-6 rounded-lg">
            <h5 className="text-primary mb-2">Rental Income</h5>
            <p className="text-body text-gray-600">Monthly passive income from our real estate portfolio</p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg">
            <h5 className="text-primary mb-2">Token Appreciation</h5>
            <p className="text-body text-gray-600">Limited supply, monthly buy back and burn drive token value growth</p>
          </div>
        </div>
      </div>
      <a
        href="https://raydium.io/swap/?inputMint=sol&outputMint=EPW6L3UrX8ArF4SVsGFNNNs2XccugnJGNNzXLeHUCNuz"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-cta inline-flex items-center group"
        data-tracking="cta-click"
        data-tracking-location="gains-card"
        data-tracking-destination="raydium"
      >
        Start Earning Now
        <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
      </a>
    </motion.div>
  );
}